<template>
  <v-container fluid>
    <v-row>
      <!-- Create panel -->
      <v-col v-if="authPermissions.has('stock_brand_types:create')" md="3" sm="12" style="padding:0">
        <create-stock-brand-type @close-dialog="createType = false"
                                 @created="$refs.indexStockBrandTypeRef?.fetchBrandTypes?.()" />
      </v-col>

      <!-- Index panel -->
      <v-col v-if="authPermissions.has('stock_brand_types:view')" md="9" sm="12">
        <v-card class="ma-0">
          <v-toolbar color="primary" dark>
            <v-card-title>Brand Types</v-card-title>
          </v-toolbar>
          <index-stock-brand-type ref="indexStockBrandTypeRef" @editBrandType="initEditType" />
        </v-card>
      </v-col>
    </v-row>

    <!-- Edit dialog -->
    <v-dialog v-model="editType" dismissable max-width="600px" eager>
      <edit-stock-brand-type :prop-type-id="propTypeData.id" :prop-type-data="propTypeData" @close-dialog="editType = false"
                             @updated="$refs.indexStockBrandTypeRef?.fetchBrandTypes?.()" />
    </v-dialog>
  </v-container>
</template>

<script>
import CreateStockBrandType from './Create.vue'
import IndexStockBrandType from './Index.vue'
import EditStockBrandType from './Edit.vue'
import { mapState } from 'vuex'

export default {
  name: 'StockBrandTypesPage',
  components: {
    CreateStockBrandType,
    IndexStockBrandType,
    EditStockBrandType,
  },
  data() {
    return {
      createType: false, // if you want to trigger dialog for creation
      editType: false,
      propTypeData: {
        id: null,
        name: null,
      },
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    initEditType(typeData) {
      this.propTypeData = typeData
      this.editType = true
    },
  },
}
</script>